export const logErrorMessage = (text: string): void => console.log(text);
